import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const BUNDLES_BUNDLE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/bundles',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:Bundles',
        layout: eLayoutType.application,
        order: 15,
        requiredPolicy: 'Enova.Bundles',
      },
    ]);
  };
}
